<template>
  <!-- Mobile Nav button section -->
  <div
    class="flex items-center justify-start fixed left-0 bg-white h-10 w-full z-40 top-0 right-0 px-2 sm:px-4 md:hidden"
  >
    <button
      id="mobile-nav-link"
      :aria-label="isCollapsed ? 'Open navigation menu' : 'Close navigation menu'"
      :aria-expanded="!isCollapsed"
      class="cursor-pointer p-2 flex flex-col items-center"
      data-test-id="mobile-nav-link"
      @click="$emit('toggle')"
    >
      <AM3Icon
        :type="isCollapsed ? 'bars-3' : 'x-mark'"
        class="h-8 w-8 text-brand"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'

interface Props {
  isCollapsed: boolean
  isMobile: boolean
}

defineProps<Props>()

defineEmits<{
  toggle: []
}>()
</script>
